// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 902 ? "c62fb0c9" : chunkId) + "." + {"604":"3efa4368d6cb98a3","902":"bbfbc3ae7b15ac66"}[chunkId] + ".js";
};